var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"select",attrs:{"items":_vm.items,"value":_vm.value,"name":"itemsPerPage","hide-details":"","single-line":"","dense":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }